import { UPDATE_NOTIFICATIONS } from "@/events/constants";

const store = window.store;

const handleUpdateNotifications = (notifications) => {
  store.dispatch("clientNotifications/setNotifications", notifications);
};

export default {
  handle(event, payload) {
    switch (event) {
      case UPDATE_NOTIFICATIONS:
        handleUpdateNotifications(payload);
        break;
    }
  },
};
